<template>
  <div class="container-box">
    <!-- <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ isEdit ? $t("claimantActivity.editActivityClaim") : $t("claimantActivity.applyActivityClaim") }}
      </div>
      <div>
        <el-button
          class="primary-btn"
          size="small"
          type="primary"
          @click="back"
          >{{ $t("operate.backList") }}</el-button
        >
      </div>
    </div> -->
    <div class="form_info">
      <el-form :inline="true" :model="addForm" :rules="rules" ref="form">
        <div class="hearder-title">
          <div class="flex_between">
            <img src="@/assets/image/basicRed.png" alt="dark" />
            {{ $t("claimantActivity.basicInfo") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item :label="$t('climant.climantNumber') + ':'">
            <el-input
              v-model="addForm.claimStatementNum"
              :placeholder="$t('climant.generatedByTheSystem')"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.activityName') + ':'" prop="activityId">
            <el-select
              v-model="addForm.activityId"
              filterable
              clearable
              @change="handleActivityChange"
              :placeholder="$t('placeholder.select')"
            >
              <el-option
                v-for="item in activityList"
                :key="item.activityId"
                :label="item.activityName"
                :value="item.activityId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.currency') + ':'">
            <el-input :value="getCurrencyText(addForm.currency)" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.activityAmount')">
            <el-input v-model="addForm.amount" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.activityDesc') + ':'" class="full-width">
            <el-input
              v-model="addForm.activityDescription"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
              disabled
              class="activity-desc-input"
            ></el-input>
          </el-form-item>
        </div>

        <div class="hearder-title">
          <div class="flex_between">
            <img src="@/assets/image/carInfo.png" alt="" />
            {{ $t("claimantActivity.vehicleInfo") }}
          </div>
        </div>
        <div class="table-container">
          <div class="table-btn">
            <el-button
              class="primary-btn"
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="handleAddVin"
              >{{ $t("zlfk.tj") }}</el-button
            >
            <el-button
              class="primary-btn"
              icon="el-icon-upload2"
              plain
              size="small"
              @click="handleImport"
              >{{ $t("zlfk.pldr") }}</el-button
            >
          </div>
          <el-table
            ref="tableRef"
            stripe
            border
            highlight-current-row
            :data="addForm.vehicleList"
            max-height="450px"
          >
            <el-table-column
              type="index"
              :label="$t('cart.xh')"
              width="60"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="vin"
              :label="$t('seek.vin')"
              min-width="180px"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.vin"
                  :placeholder="$t('placeholder.enter')"
                  @blur="handleVinBlur(scope.row)"
                  v-loading="vinLoading"
                  clearable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              property="carBrand"
              :label="$t('home.brand')"
              min-width="100"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.carBrand"
                  :placeholder="$t('placeholder.enter')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              property="carModel"
              :label="$t('home.carType')"
              min-width="120"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.carModel"
                  :placeholder="$t('placeholder.enter')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              property="carAttribute"
              :label="$t('climant.carAttribute')"
              min-width="100"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <el-select v-model="scope.row.carAttribute" clearable>
                  <el-option :label="$t('climant.ryc')" :value="0"> </el-option>
                  <el-option :label="$t('climant.ddc')" :value="1"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              property="productionDate"
              :label="$t('seek.produceDate')"
              width="170"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="scope.row.productionDate"
                  :placeholder="$t('placeholder.select')"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('home.attachmentInfo')"
              min-width="230"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="file-thumbnails">
                  <div
                    v-for="(file, index) in (scope.row.fileList || []).slice(0, 3)"
                    :key="index"
                    class="thumbnail-item"
                    @click="handlePreviewFile(scope.row.fileList, index)"
                  >
                    <img :src="getFileIcon(file)" alt="" />
                    <span class="file-name" :title="file.name || file.fileName">
                      {{ (file.name || file.fileName || '').substring(0, 8) }}...
                    </span>
                    <i class="el-icon-close delete-icon" @click.stop="handleRemoveFile(scope.row, index)"></i>
                  </div>
                  <div v-if="(scope.row.fileList || []).length > 3" class="more-files">
                    +{{ scope.row.fileList.length - 3 }}
                  </div>
                  <el-button type="text" size="small" @click="handleUploadFile(scope.row, scope.$index)" class="upload-btn">
                    <i class="el-icon-plus"></i>
                    {{ $t("upgrade.upload") }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('cart.operate')"
              width="80"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDeleteVin(scope.$index)"
                >{{ $t("cart.delete") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="total-row">
            <span>{{ $t("claimantActivity.vinCount") }}: {{ vinCount }}</span>
            <span style="margin-left: 30px"
              >{{ $t("claimantActivity.totalAmount") }}: {{ totalAmount }}</span
            >
          </div>
        </div>
      </el-form>
      <div class="flex_default_center">
        <el-button type="primary" @click="handleSubmit">{{ $t("seek.submit") }}</el-button>
        <el-button type="primary" plain @click="handleSaveDraft">{{ $t("home.saveDraft") }}</el-button>
        <el-button @click="back">{{ $t("seek.cancel") }}</el-button>
      </div>
    </div>
    <import-model-dialog
      ref="importModelDialog"
      @success="getImportList"
      :uploadUrl="importUrl"
      :templateUrl="templateUrl[$i18n.locale]"
    />
    <vin-file-upload-dialog
      ref="vinFileUploadDialog"
      :rowData="currentEditRow"
      @save="handleFileSave"
    />
    <view-img-video ref="viewImgVideoRef" :list="previewFileList" />
  </div>
</template>

<script>
import ImportModelDialog from "@/components/importModelDialog.vue";
import vinFileUploadDialog from "./vinFileUploadDialog.vue";
import viewImgVideo from "@/components/viewImgVideo.vue";
import {
  saveActivityClaim,
  getActivitySupportList,
  getActivityClaimDetail,
  checkClaimedVinsApi,
} from "@/api/activityClaimant";
import { getECPDataByVIN } from "@/api/seek";
import { getStorage, getSession } from "@/util/localStor";
import CryptoJS from "crypto-js";
import {uploadUrl} from "@/util/url";

export default {
  components: {
    ImportModelDialog,
    vinFileUploadDialog,
    viewImgVideo,
  },
  data() {
    return {
      addForm: {
        claimStatementNum: "",
        activityId: "",
        activityDescription: "",
        currency: "",
        amount: "",
        vehicleList: [],
      },
      activityList: [],
      vinLoading: false,
      // importUrl: "/activity-claimant/import-vin",
      importUrl: uploadUrl + "/customer/car/feedback/importVin", // 导入地址
      templateUrl: {
        zh: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/d222388533a6475c8ca9cb5ad77417b2.xlsx",
        en: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/1103c38bb54a41f4937489c8890608ea.xlsx",
        ru: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/60f9cb49d5b24ed7ae2e12316a825ae2.xlsx",
        fa: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/a2229cf1ee7941f8a7fb0842b5e457c7.xlsx",
      },
      currentEditRow: null,
      currentEditIndex: null,
      previewFileList: [],
      isEdit: false,
      rules: {
        activityId: [
          {
            required: true,
            message: this.$t("placeholder.select"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    vinCount() {
      return this.addForm.vehicleList.length;
    },
    totalAmount() {
      return (
        (this.addForm.amount || 0) * this.vinCount
      ).toFixed(2);
    },
  },
  mounted() {
    this.getActivityList();
    const data = getStorage("activityClaimantData");
    if (data && (data.activityClaimId || data.id)) {
      this.isEdit = true;
      if (data.activityClaimId) {
        this.getDetailData(data.activityClaimId);
      } else {
        this.addForm = { ...this.addForm, ...data };
      }
    }
  },
  methods: {
    async getDetailData(activityClaimId) {
      const res = await getActivityClaimDetail({
        data: { activityClaimId: activityClaimId },
      });
      if (res.status == 0 && res.data) {
        this.addForm = { ...this.addForm, ...res.data };
      }
    },
    getCurrencyText(currency) {
      const currencyMap = {
        0: "CNY",
        1: "USD",
        2: "EUR",
        3: "GBP"
      };
      return currencyMap[currency] || currency || "";
    },
    async getActivityList() {
      const res = await getActivitySupportList({
        data: {},
        page: { pageNum: 1, pageSize: 999 },
      });
      if (res.status == 0) {
        this.activityList = res.data || [];
      }
    },
    handleActivityChange(val) {
      if (val) {
        const activity = this.activityList.find((item) => item.activityId === val);
        if (activity) {
          this.addForm.activityDescription = activity.activityDescription || "";
          this.addForm.currency = activity.currency || "";
          this.addForm.amount = activity.amount || 0;
        }
      } else {
        this.addForm.activityDescription = "";
        this.addForm.currency = "";
        this.addForm.amount = 0;
      }
    },
    handleAddVin() {
      this.addForm.vehicleList.push({
        vin: "",
        carBrand: "",
        carModel: "",
        carAttribute: null,
        productionDate: "",
        fileUrl: "",
        fileList: [],
      });
    },
    handleDeleteVin(index) {
      this.addForm.vehicleList.splice(index, 1);
    },
    handleUploadFile(row, index) {
      this.currentEditRow = row;
      this.currentEditIndex = index;
      this.$refs.vinFileUploadDialog.init();
    },
    handleFileSave(fileList) {
      if (this.currentEditIndex !== null) {
        const existingList = this.addForm.vehicleList[this.currentEditIndex].fileList || [];
        this.addForm.vehicleList[this.currentEditIndex].fileList = [...existingList, ...fileList];
      }
    },
    getFileIcon(file) {
      const fileName = file.name || file.fileName || "";
      const ext = fileName.split(".").pop().toLowerCase();
      const imgExts = ["jpg", "jpeg", "png", "gif", "svg", "bmp"];
      const videoExts = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "3gp", "m4v"];
      const docExts = ["doc", "docx", "pdf", "txt"];
      const xlsExts = ["xls", "xlsx"];
      const zipExts = ["zip", "rar", "7z"];

      if (imgExts.includes(ext)) {
        return file.url || file.filePath || "";
      } else if (videoExts.includes(ext)) {
        return require("@/assets/image/mp4.png");
      } else if (xlsExts.includes(ext)) {
        return require("@/assets/image/xls.png");
      } else if (docExts.includes(ext)) {
        return require("@/assets/image/doc.png");
      } else if (zipExts.includes(ext)) {
        return require("@/assets/image/zip.png");
      }
      return require("@/assets/image/fileIcon.png");
    },
    handlePreviewFile(fileList, index) {
      const imgExts = ["jpg", "jpeg", "png", "gif", "svg", "bmp"];
      const previewList = fileList.filter(file => {
        const fileName = file.name || file.fileName || "";
        const ext = fileName.split(".").pop().toLowerCase();
        return imgExts.includes(ext);
      });
      if (previewList.length > 0) {
        this.previewFileList = previewList;
        const fileItem = fileList[index];
        this.$nextTick(() => {
          this.$refs.viewImgVideoRef.init(fileItem, previewList);
        });
      }
    },
    handleRemoveFile(row, index) {
      row.fileList.splice(index, 1);
    },
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat).toString().toUpperCase();
      return { appId, timestamp, sign };
    },
    async handleVinBlur(row) {
      if (row.vin) {
        this.vinLoading = true;
        try {
          const { appId, timestamp, sign } = this.getECPParams();
          const params = {
            appId,
            timestamp,
            sign,
            vin: row.vin,
            account: getSession("person").customerAccountNum,
          };
          const res = await getECPDataByVIN(params);
          if (res.data && res.data.length > 0) {
            row.carBrand = res.data[0].brand || "";
            row.carModel = res.data[0].model || "";
            row.productionDate = res.data[0].vinCreated || "";
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.vinLoading = false;
        }
      }
    },
    handleImport() {
      this.$refs.importModelDialog.init(this.$t("zlfk.pldr"));
    },
    getImportList(data) {
      if (data && data.length > 0) {
        const newList = data.map((item) => ({
          vin: item.vin || "",
          carBrand: item.brand || "",
          carModel: item.carModel || "",
          carAttribute: item.carAttribute,
          productionDate: item.vinCreated || "",
          fileUrl: item.fileUrl || "",
          fileList: item.fileList || [],
        }));
        const allList = [...this.addForm.vehicleList, ...newList];
        this.addForm.vehicleList = allList.filter(
          (item, index, arr) => arr.findIndex((obj) => obj.vin === item.vin) === index
        );
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.addForm.vehicleList.length === 0) {
            this.$DonMessage.warning(this.$t("claimantActivity.vehicleTip"));
            return;
          }
          // 检查重复VIN
          const dupMsg = this.checkDuplicateVin();
          if (dupMsg) {
            this.$DonMessage.warning(dupMsg);
            return;
          }
          // 检查VIN是否已被索赔
          const claimedMsg = await this.checkClaimedVins();
          if (claimedMsg) {
            this.$DonMessage.warning(claimedMsg);
            return;
          }
          const res = await saveActivityClaim({
            data: { ...this.addForm, status: 1 },
          });
          if (res.status == 0) {
            this.$DonMessage.success(this.$t("message.czcg"));
            this.$router.push("/activityClaimant");
          } else {
            this.$DonMessage.warning(res.message);
          }
        }
      });
    },
    async handleSaveDraft() {
      // 检查重复VIN
      const dupMsg = this.checkDuplicateVin();
      if (dupMsg) {
        this.$DonMessage.warning(dupMsg);
        return;
      }
      // 检查VIN是否已被索赔
      const claimedMsg = await this.checkClaimedVins();
      if (claimedMsg) {
        this.$DonMessage.warning(claimedMsg);
        return;
      }
      const res = await saveActivityClaim({
        data: { ...this.addForm, status: 0 },
      });
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.$router.push("/activityClaimant");
      } else {
        this.$DonMessage.warning(res.message);
      }
    },
    // 检查车辆列表中是否存在重复VIN，返回警告信息（无重复则返回空字符串）
    checkDuplicateVin() {
      const vins = this.addForm.vehicleList.map(v => v.vin).filter(v => v);
      const seen = {};
      const duplicates = [];
      vins.forEach(vin => {
        if (seen[vin]) {
          duplicates.push(vin);
        } else {
          seen[vin] = true;
        }
      });
      if (duplicates.length > 0) {
        const uniqueDups = [...new Set(duplicates)];
        return this.$t("claimantActivity.duplicateVin") + ": " + uniqueDups.join(", ");
      }
      return "";
    },
    // 检查VIN是否已被索赔，返回已索赔VIN提示（无已索赔则返回空字符串）
    async checkClaimedVins() {
      const vins = this.addForm.vehicleList.map(v => v.vin).filter(v => v);
      if (vins.length === 0) return "";
      const res = await checkClaimedVinsApi({
        data: {
          vins,
          excludeClaimId: this.addForm.activityClaimId || "",
        },
      });
      if (res.status == 0 && res.data && res.data.length > 0) {
        return this.$t("claimantActivity.vinClaimed") + ": " + res.data.join(", ");
      }
      return "";
    },
    back() {
      this.$router.push("/activityClaimant");
    },
  },
};
</script>

<style lang="scss" scoped>

// .form_add_page {
//   padding: 20px;
// }
.total-row {
  margin-top: 15px;
  padding: 10px;
  background: #f5f7fa;
  font-weight: bold;
}
// .bottom-btn {
//   margin-top: 30px;
//   text-align: center;
// }
// .activity-desc-input {
//   width: 522px;
// }
::v-deep .full-width {
  display: block;
  margin-right: 80px;
}
::v-deep .full-width .el-form-item__content {
  width: 500px;
}
::v-deep .el-table .el-date-editor.el-input {
  width: 100%;
}
 .file-thumbnails {
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   justify-content: center;
   gap: 5px;
 }
 .thumbnail-item {
   position: relative;
   width: 50px;
   height: 50px;
   border: 1px solid #ddd;
   border-radius: 4px;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   overflow: hidden;
 }
 .thumbnail-item img {
   width: 30px;
   height: 30px;
   object-fit: contain;
 }
 .thumbnail-item .file-name {
   font-size: 10px;
   color: #666;
   max-width: 100%;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
 }
 .thumbnail-item .delete-icon {
   position: absolute;
   top: 2px;
   right: 2px;
   font-size: 12px;
   color: #f56c6c;
   cursor: pointer;
   display: none;
 }
 .thumbnail-item:hover .delete-icon {
   display: block;
 }
// .more-files {
//   width: 50px;
//   height: 50px;
//   border: 1px dashed #ddd;
//   border-radius: 4px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: #999;
//   font-size: 12px;
// }
// .upload-btn {
//   width: 50px;
//   height: 50px;
//   border: 1px dashed #ddd;
//   border-radius: 4px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// .upload-btn i {
//   font-size: 20px;
//   color: #999;
// }
</style>
